module.exports = __webpack_public_path__ + "static/img/men.f22693c6.svg";